import { Component } from '@angular/core';
import { Product, ProductScope } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
  selector: 'product-efficiency',
  templateUrl: './product-efficiency.component.html',
  styleUrl: './product-efficiency.component.scss',
  standalone: false,
})
export class ProductEfficiencyComponent {
  product$: Observable<Product | null> = this.currentProductService.getProduct([
    ProductScope.DETAILS,
    ProductScope.PRICE,
  ]);

  constructor(private currentProductService: CurrentProductService) {}
}
